/**
 * Idioma do documento e das superfícies.
 *
 * Decisão de 2026-09-28: **tudo segue a clínica**, incluindo os rótulos da
 * superfície interna. Na esmagadora maioria dos casos a assinatura acontece no
 * tablet do delegado, pousado na mesa à frente de quem assina — o ecrã é lido
 * pela clínica, não pelo delegado.
 *
 * A fonte é o campo `Pa_s` da Company, o mesmo que já decide que distribuidores
 * podem ser oferecidos.
 */

export const IDIOMAS = ['pt', 'es'] as const;
export type Idioma = (typeof IDIOMAS)[number];

export const IDIOMA_POR_OMISSAO: Idioma = 'pt';

/** Valores do picklist `Pa_s` do Bigin → idioma. */
const POR_PAIS: Record<string, Idioma> = {
	Portugal: 'pt',
	Spain: 'es'
};

/**
 * País desconhecido ou por preencher cai no idioma por omissão — nunca falha.
 * É a mesma postura do filtro de distribuidores: degradar, não bloquear.
 */
export function idiomaDoPais(pais: string | null | undefined): Idioma {
	if (!pais) return IDIOMA_POR_OMISSAO;
	return POR_PAIS[pais] ?? IDIOMA_POR_OMISSAO;
}

/** Aceita o que vier do exterior (query string, por exemplo) sem confiar nele. */
export function idiomaValido(valor: unknown): Idioma {
	return IDIOMAS.includes(valor as Idioma) ? (valor as Idioma) : IDIOMA_POR_OMISSAO;
}
